import React from 'react';
import { Helmet } from 'react-helmet';

// eslint-disable-next-line react/prop-types
const Header = ({ shopName, barberName, service, dateShort }) => (
  <div className="u-pt-30 u-pr-4 u-pl-4 u-mb-4 u-text-small u-co-grey--light u-ta-center">
    <Helmet>
      <title>New Appointment | {shopName}</title>
    </Helmet>
    {barberName} has a new {service} appointment {dateShort}
  </div>
);

export default Header;



// WEBPACK FOOTER //
// ./src/app/notifications/shop/ShopNewAppointment/components/Header.jsx